import { getYoutubeThumbnailUrlByVideoId } from "$lib/utilities/components/embeds";
import { buildSrc } from "$lib/utilities";

export const getVideoComponentPropsForVideoContentType = (data) => {
  const defaultThumbnail = getYoutubeThumbnailUrlByVideoId(data.fields?.embedID);

  return {
    header: data.fields?.videoTitle,
    body: data.fields?.description,
    caption: data.fields?.caption,
    loopSection: {
      startTime: data.fields?.loopStart || 0,
      endTime: data.fields?.loopEnd
    },
    videoCoverImage: defaultThumbnail
      ? {
          src: defaultThumbnail,
          alt: ""
        }
      : undefined,
    videoId: data.fields?.embedID
  };
};

export const getContentfulVideoComponentProps = (videoData, featuredImage) => {
  return {
    videoTitle: videoData.fields?.title,
    videoUrl: videoData.fields?.file?.url,
    contentType: videoData.fields?.file?.contentType,
    posterImageUrl: featuredImage ? buildSrc(featuredImage.fields.imageAsset, { w: 3000 }) : null
  };
};
